<template>
  <app-panel
    :subtitle="$t('teacher.page.contact.subtitle')"
    :title="$t('teacher.page.contact.title', { name: teacher.first_name })"
  >
    <growth-contact-button
      block
      origin="trainer"
      origin_page_action="main_contact_cta"
      :origin_page_id="teacher.slug!"
      size="lg"
    >
      {{ $t("teacher.page.contact.cta") }}
    </growth-contact-button>
  </app-panel>
</template>

<script lang="ts" setup>
import type { TeacherPageView } from "~/business-areas/teacher/teacher.model";

defineProps<{
  teacher: TeacherPageView;
}>();
</script>
